import React, { useState } from "react";
import "./ProPayment.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
const UPI_ID = "vinodkumarvinumk@oksbi";

function ProPayment() {
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("userId");

  const handlePayment = async () => {
    if (!userId) {
      alert("Please login first.");
      return;
    }

    try {
      setLoading(true);

      // 1. Try ToroPay first
      const response = await fetch(API_URL + "/api/toropay/create-payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: userId, amount: 29 }),
      });

      const data = await response.json();
      console.log("ToroPay Response:", data);

     
      if (response.ok && data.success && data.paymentUrl) {
        window.location.href = data.paymentUrl;
        return;
      }

      console.warn("ToroPay failed, using Direct UPI:", data.message);
      const refId = data.referenceId || `PRO_${userId}_${Date.now()}`;
      
      // Save for verification
      localStorage.setItem("pro_ref", refId);
      localStorage.setItem("pro_pending", "true");

    
      const upiLink = `upi://pay?pa=${UPI_ID}&pn=TheBlogsSphere&am=29&cu=INR&tn=${refId}`;
      window.location.href = upiLink;

     
      setTimeout(() => {
        window.location.href = `/pro-pending?ref=${refId}`;
      }, 8000);

    } catch (error) {
      console.error("ToroPay Payment Error:", error);
      
      
      const refId = `PRO_${userId}_${Date.now()}`;
      const upiLink = `upi://pay?pa=${UPI_ID}&pn=TheBlogsSphere&am=29&cu=INR&tn=${refId}`;
      window.location.href = upiLink;
      setTimeout(() => {
        window.location.href = `/pro-pending?ref=${refId}`;
      }, 8000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pro-wrapper">
      <div className="pro-card">
        <div className="pro-badge">PRO PLAN</div>
        <h1 className="pro-title">TheBlogsSphere PRO</h1>
        <p className="pro-sub">Unlock all premium features for 30 days</p>

        <div className="pro-features">
          <div className="pro-feat"><span>✓</span><span>Monetize Your Blogs</span></div>
          <div className="pro-feat"><span>✓</span><span>Boost to 5000+ Users</span></div>
          <div className="pro-feat"><span>✓</span><span>Verified Badge</span></div>
          <div className="pro-feat"><span>✓</span><span>No Ads</span></div>
          <div className="pro-feat"><span>✓</span><span>Premium Creator Features</span></div>
          <div className="pro-feat"><span>✓</span><span>30 Days PRO Access</span></div>
        </div>

        <div className="pro-price-box">
          <span className="pro-old">₹99</span>
          <span className="pro-new">₹29</span>
          <span className="pro-valid">/ 30 days</span>
        </div>

        <button
          type="button"
          className="pro-pay-btn"
          onClick={handlePayment}
          disabled={loading}
        >
          {loading ? "Opening..." : "Pay ₹29"}
        </button>

        <p className="pro-secure">
          🔒 Secure payment • UPI, Card, NetBanking
        </p>
        <p className="pro-note">
          
          UPI payment • Secure checkout • 30-day PRO access
        </p>
      </div>
    </div>
  );
}

export default ProPayment;